module.exports = __webpack_public_path__ + "img/doctor-3.c66ab50a.png";